var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container is-widescreen app-main" },
    [_c("router-view", { staticClass: "section animated" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }